import { FabricObject } from 'fabric';
import { useEffect, useMemo, useState } from 'react';

import { Coords, SpreadGroundImage } from 'editor/src/store/design/types';

import loadImage from 'editor/src/util/loadImage';

import createSpreadMaskClipPath from './createSpreadMaskClipPath';

const imageCache = new Map<string, Promise<HTMLImageElement | undefined>>();

function loadCachedImage(url: string) {
  const cached = imageCache.get(url);
  if (cached) {
    return cached;
  }

  const promise = loadImage(url, 'anonymous', { executor: 'useSpreadMaskClipImage' }).catch(() => undefined);
  imageCache.set(url, promise);
  return promise;
}

function useSpreadMaskClipImage(
  maskImageData: SpreadGroundImage | undefined,
  spreadWidth: number,
  spreadHeight: number,
  spreadCoords: Coords,
) {
  const [maskImage, setMaskImage] = useState<HTMLImageElement | undefined>();

  useEffect(() => {
    let active = true;
    if (!maskImageData?.url) {
      setMaskImage(undefined);
      return undefined;
    }

    void loadCachedImage(maskImageData.url).then((img) => {
      if (active) {
        setMaskImage(img);
      }
    });

    return () => {
      active = false;
    };
  }, [maskImageData?.url]);

  return useMemo<FabricObject | undefined>(() => {
    if (!maskImageData || !maskImage) {
      return undefined;
    }

    return createSpreadMaskClipPath(maskImageData, maskImage, spreadWidth, spreadHeight, spreadCoords);
  }, [maskImageData, maskImage, spreadCoords.left, spreadCoords.top, spreadWidth, spreadHeight]);
}

export default useSpreadMaskClipImage;
